'use strict';

import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/*
 * Global file download service.
 * Allows download of files in a one-page, ajax application.
 *
 * Please note that resource returning files must use FileDownloadUtils.setFileDownloadCookie
 * to correctlty use $.fileDownload directive.
 */
ngModule.factory("$fileDownload", function ($q, security, $http, $httpErrorHandler, $dateConverter, $dialogBox, $notifications, urlUtils) {
  function failBackErrorHandler() {
    $dialogBox.alert({
      title: "Erreur",
      html: "Impossible de télécharger le fichier.<br/>Désolé nous n'avons pas de détail sur l'incident, contactez le support si il persiste."
    });
  }
  var syncDownload = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(deferred, authenticatedUrl, options, data) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            $.fileDownload(authenticatedUrl, {
              httpMethod: options.method || "GET",
              cookieName: "fileDownload",
              cookieValue: "true",
              cookiePath: "/",
              data: $dateConverter.formatObject(data || {}),
              successCallback: function successCallback(url) {
                deferred.resolve();
              },
              failCallback: function failCallback(responseHtml, url) {
                // might be browser-dependent, so we try-proof it.
                try {
                  var error = JSON.parse($(responseHtml).text());
                  error.httpCode = 500;
                  $httpErrorHandler.handleServerError(error);
                } catch (e) {
                  failBackErrorHandler();
                }
                deferred.reject();
              }
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function syncDownload(_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }();
  var wait = function wait(ms) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, ms);
    });
  };
  var waitForCompletion = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(taskId) {
      var status;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            status = 'PENDING';
          case 1:
            if (!(status != 'COMPLETED' && status != 'ERROR')) {
              _context2.n = 4;
              break;
            }
            _context2.n = 2;
            return $http.get('/rest/user-tasks/status/' + taskId).then(function (response) {
              status = response.data;
            });
          case 2:
            _context2.n = 3;
            return wait(2000);
          case 3:
            _context2.n = 1;
            break;
          case 4:
            return _context2.a(2, status);
        }
      }, _callee2);
    }));
    return function waitForCompletion(_x5) {
      return _ref2.apply(this, arguments);
    };
  }();
  var asyncDownload = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(deferred, authenticatedUrl, options, data) {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            $http.post('/rest/async-download/execute', {
              method: options && options.method || 'GET',
              url: authenticatedUrl,
              data: data
            }).then(function (response) {
              $notifications.info("Le téléchargement a démarré, vous serez notifié quand il sera terminé.");
              var taskId = response.data.response;
              waitForCompletion(taskId).then(function (status) {
                if (status == 'COMPLETED') {
                  var authenticatedDownloadUrl = urlUtils.addParams("/rest/user-tasks/downloadUserTaskGeneratedFile/" + taskId, security.getTokens());
                  syncDownload(deferred, authenticatedDownloadUrl, {}, {});
                  if (options.onSuccess) {
                    options.onSuccess();
                  }
                  $notifications.info("Téléchargement terminé");
                } else {
                  if (options.onFailure) {
                    options.onFailure();
                  }
                  $notifications.error("Téléchargement en erreur");
                  deferred.reject("Téléchargement en erreur");
                }
              });
            });
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function asyncDownload(_x6, _x7, _x8, _x9) {
      return _ref3.apply(this, arguments);
    };
  }();
  return {
    /**
     * Start the download of a resource.
     *
     * @param {String} url The url to download the resource from.
     * @param {Object} [data] The data to send with the request, either via query param for GET requests, or envelope for POST requests
     * @param {Object} [options] Optional configuration options for the download
     *                           - method : The http method to use, either 'GET' or 'POST'
     * @return {deferred.promise|*} A promise resolving when the file download is completed.
     */
    start: function start(url, data, options) {
      var deferred = $q.defer();
      options = options || {};
      var httpMethod = options.method || "GET";
      var async = options.async || false;
      var authenticatedUrl = urlUtils.addParams(url, security.getTokens());
      if (httpMethod === "POST" && data != null) {
        // see FormEncodedGsonMessageBodyReader for details...
        data = {
          POST_DATA: JSON.stringify($dateConverter.formatObject(data || {}))
        };
      }
      if (async) {
        asyncDownload(deferred, authenticatedUrl, options, data);
      } else {
        syncDownload(deferred, authenticatedUrl, options, data);
      }
      ;
      return deferred.promise;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/file-download/$fileDownload.js
// module id = 2934
// module chunks = 13